import React from 'react';
import Weather from './components/Weather';

function App() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded shadow-lg">
        <h2 className="text-2xl font-bold mb-4">Weather App</h2>
        <p className="text-gray-800">Enter city name to get current weather report in Celsius.</p>
          <Weather />
      </div>
    </div>
  );
}

export default App;
